import { fabric } from "fabric"
import Calc from "@/common/util/calculator"
import Form from "./base"
import PathObject from "../objects/path"
import pathRounding from "@/signomatic/util/path_rounding"
import type { DrawableMixin } from "../objects/drawable_mixin"

export default class RotatedRectForm extends Form {
  protected path(width: number, height: number, rounding: number) {
    const commands = [this.pathMoveTo(-(width / 2), 0)]

    commands.push(this.pathLineToAbs(0, -(height / 2)))
    commands.push(this.pathLineToAbs(width / 2, 0))
    commands.push(this.pathLineToAbs(0, height / 2))
    commands.push(this.pathClose())

    const path = pathRounding(commands.join(" "), rounding).join("")

    return this.scaleToSize(new PathObject(path, this.defaultParams), width, height)
  }

  protected snappablePaths(width: number, height: number, rounding: number): [DrawableMixin, DrawableMixin] | null {
    const path = this.path(width, height, rounding) as unknown as fabric.Path

    if (path.path) {
      const pathCmds: any[] = [...path.path]
      const sideCmds = [pathCmds.shift(), pathCmds.shift()]

      pathCmds.pop() // Z
      const restCmds = [["M", sideCmds[1][1], sideCmds[1][2]], ...pathCmds]

      const params: fabric.IObjectOptions = {
        ...this.defaultParams,
        scaleX: path.scaleX,
        scaleY: path.scaleY,
        top: 0,
        left: 0,
      }

      const side = new PathObject(sideCmds, params)
      side.pathOffset = new fabric.Point(0, 0)

      return [side, new PathObject(restCmds, params)]
    }

    return null
  }

  protected get baseRounding() {
    return this.calcRounding()
  }

  protected get cutlineRounding() {
    return this.printCutlineRounding(this.calcRounding())
  }

  private calcRounding() {
    const { widthPx, heightPx, height, fixmethod, material } = this.state
    let radius = Math.min(widthPx, heightPx) / 10

    if (this.signType === "aluminium_sign") {
      radius = Math.min(height / 2, this.drawables.sizeRelative("width", Calc.mmToPx(3), Calc.mmToPx(70)))
    }

    if (
      ["forex_sign", "solid_plastic_sign", "ecoboard"].includes(this.signType) ||
      (this.signType === "double_sided_sign" && material === "plastic")
    ) {
      radius = Math.max(radius, Calc.mmToPx(5))
    }

    if (fixmethod === "military") {
      radius *= 0.8
    }

    return radius
  }
}
